<script setup lang="ts">
definePageMeta({
  middleware: ['02-pharmacy-routing'],
  nonPharmacyRoute: 'themenuebersicht-slug',
})
</script>

<template>
  <p>{{ $route.name }}</p>
</template>
